import styled from '@src/styled-components';
import { Button } from 'antd';
import React from 'react';


type PropsType = {
    buttonText: string;
    onClick: any;
    style?: any;
    disabled?:boolean;
    loading?: boolean;
};

export default class RegisterBtnComponent extends React.Component<PropsType> {

    render() {
        const { buttonText } = this.props;

        return (
            <div>
                {
                    <Container style={this.props.style}>
                        <Button loading={this.props.loading} disabled={this.props.disabled} type="primary" size="large" className='register-button' onClick={this.props.onClick}>
                            {(!!buttonText) ? buttonText : "@LABELERROR"}
                        </Button>
                    </Container>
                }
            </div>
        )
    }
}

const Container = styled.div`
    .register-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }    
`;